import { Box, styled as muiStyled, Grid, Typography, Switch, FormControlLabel, Button } from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import styled from "styled-components";
import BackPageButton from "../../components/common-components/BackPageButton";
import CustomButton from "../../components/common-components/CustomButton";
import FormInputField from "../../components/common-components/FormInputField";
import { Title } from "../../components/style/modalStyle";
import SelectInputField from "../../components/common-components/SelectInputField";
import { useState, useRef, useEffect } from "react";
import { useAppDispatch } from "../../stores/store";
import { addService, updateService, getSingleService } from "../../stores/services";
import { setToast } from "../../stores/toast/toastslice";
import { useNavigate, useParams } from "react-router-dom";
import {number} from "yup";
import ListLoadingNew from "../../components/common-components/ListLoadingNew";

const ToggleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
`;

const CustomToggle = styled.button<{
  checked: boolean;
}>`
  width: 60px;
  height: 32px;
  border-radius: 100px;
  border: none;
  background: ${({ checked }) => (checked ? '#2977CC' : '#EAF1FA')};
  position: relative;
  cursor: pointer;
  transition: background 0.2s;
  outline: none;
  &:before {
    content: '';
    position: absolute;
    left: ${({ checked }) => (checked ? '32px' : '4px')};
    top: 4px;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: #fff;
    box-shadow: 0 1px 4px rgba(0,0,0,0.08);
    transition: left 0.2s;
  }
`;

const RecurringInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 225px;
`;

const RecurringInputsFlex = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
  @media (max-width: 600px) {
    flex-direction: column;
    gap: 12px;
  }
`;

const AddEditService = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [getLoading, setGetLoading] = useState(false);

  const formik = useFormik({
    initialValues: {
      service_name: "",
      price: "",
      description: "",
      is_recurring: false,
      recurring_amount: "",
      recuring: "",
      recurring_type: "",
    },
    validationSchema: Yup.object({
      service_name: Yup.string().required("Service name is required"),
      price: Yup.number()
          .typeError("Price must be a number")
          .required("Price is required")
          .max(999999, "Only up to 999999 is allowed")
          .test("is-decimal", "Max 2 decimals allowed", (val) =>
              /^\d+(\.\d{1,2})?$/.test(val?.toString() || "")
          ),
      // recurring_amount: Yup.number().when("is_recurring", {
      //   is: true,
      //   then: (schema) =>
      //       schema
      //           .typeError("Recurring amount must be a number")
      //           .required("Recurring amount is required"),
      //   otherwise: (schema) => schema.notRequired(),
      // }),
      recuring: Yup.number().when("is_recurring", {
        is: true,
        then: (schema) =>
            schema
                .typeError("Recurring period must be a number")
                .required("Recurring period is required")
                .min(1, "Recurring period must be at least 1"),
        otherwise: (schema) => schema.notRequired(),


    }),

      description: Yup.string().required("Description is required")
      .max(1000, "Description cannot exceed 1000 characters"),


      recurring_type: Yup.string().when('is_recurring', {
        is: true,
        then: () => Yup.string().required("Recurring type is required"),
        otherwise: () => Yup.string(),
      }),
    }),
    onSubmit: async (values) => {
      setLoading(true);
      try {
        const trimmedValues = {
          service_name: values.service_name.trim(),
          description: values.description.trim(),
          price: values.price,
          is_recurring: values.is_recurring,
          recurring_amount: values.recurring_amount,
          recuring: values.recuring,
          recurring_type: values.recurring_type.trim(),
        };

        const payload = {
          service_name: trimmedValues.service_name,
          description: trimmedValues.description,
          price: trimmedValues.is_recurring
              ? Number(trimmedValues.recurring_amount)
              : Number(trimmedValues.price),
          is_recurring_service: trimmedValues.is_recurring,
          recurring_every: trimmedValues.is_recurring ? trimmedValues.recurring_type : "",
          recuring: trimmedValues.recuring || 0,
        };

        console.log("1. Starting form submission with payload:", payload);

        let response;
        if (id) {
          console.log("2a. Updating service with ID:", id);
          try {
            const result = await dispatch<any>(updateService({ id: Number(id), ...payload })).unwrap();
            console.log("3a. Update API Result:", result);
            response = result;
          } catch (error) {
            console.error("Error updating service:", error);
            throw error;
          }
        } else {
          console.log("2b. Adding new service");
          try {
            const result = await dispatch<any>(addService(payload)).unwrap();
            console.log("3b. Add API Result:", result);
            response = result;
          } catch (error) {
            console.error("Error adding service:", error);
            throw error;
          }
        }

        console.log("4. Processed API Response:", response);

        if (response?.status === 1) {
          console.log("5. Success case - navigating to services list");
          dispatch<any>(setToast({
            type: "success",
            message: response?.message ||  "Service added successfully!",
            title: "Success"
          }));

          setTimeout(() => {
            navigate("/admin-services");
          }, 100);
        } else {
          console.log("6. Error case - showing error toast");
          dispatch<any>(setToast({
            type: "error",
            message: response?.message || "Something went wrong!",
            title: "Error"
          }));
        }
      } catch (error: any) {
        console.error("7. Caught error in form submission:", error);
        dispatch<any>(setToast({
          type: "error",
          message: error?.message || "Something went wrong!",
          title: "Error"
        }));
      } finally {
        setLoading(false);
      }
    },
  });

  console.log('formikerr',formik.errors)

  useEffect(() => {
    const fetchServiceDetails = async () => {
      if (id) {
        setGetLoading(true);
        try {
          const response = await dispatch<any>(getSingleService(Number(id))).unwrap();
          if (response) {
            const serviceData = response;
            formik.setValues({
              service_name: serviceData.service_name || "",
              price: serviceData.price || 0,
              description: serviceData.description || "",
              is_recurring: serviceData.is_recurring_service || false,
              recurring_amount: serviceData.price || 0,
              recuring: serviceData.recuring || 0,
              recurring_type: serviceData.recurring_every || "",
            });
            formik.setFieldValue("is_recurring", serviceData.is_recurring_service || false);
          }
          setGetLoading(false);
        } catch (error) {
          dispatch<any>(setToast({
            type: "error",
            message: "Failed to fetch service details",
            title: "Error"
          }));
          setGetLoading(false);
        }
      }
    };

    fetchServiceDetails();
  }, [id, dispatch]);

  const [isRecurring, setIsRecurring] = useState(formik.initialValues.is_recurring);
  const [selectedFiles, setSelectedFiles] = useState<{ file: File; preview: string }[]>([]);
  const [galleryImages, setGalleryImages] = useState<string[]>([]);

  const quillRef = useRef<any>(null);

  const handleImageUpload = () => {
    document.getElementById("attachment-description")?.click();
  };

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (files && files.length > 0) {
      const fileArray = Array.from(files);
      fileArray.forEach(file => {
        const reader = new FileReader();
        reader.onload = () => {
          setGalleryImages(prev => [...prev, reader.result as string]);
        };
        reader.readAsDataURL(file);
      });
    }
    e.target.value = '';
  };

  const handleEditorChange = (content: string) => {
    formik.setFieldValue("description", content);
    setTimeout(() => {
      const quill = quillRef.current?.getEditor?.();
      if (quill) {
        const editorElem = quill.root as HTMLElement;
        const imgs = Array.from(editorElem.querySelectorAll("img")).map(img => img.getAttribute("src") || "");
        setGalleryImages(imgs.filter(Boolean));
      }
    }, 0);
  };

  const handleRemoveImage = (src: string) => {
    setGalleryImages(prev => prev.filter(img => img !== src));
  };

  const modules = {
    toolbar: {
      container: [
        [{ header: [1, 2, 3, false] }],
        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["link", "image"],
        ["clean"],
      ],
      handlers: {
        image: handleImageUpload,
      },
    },
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "list",
    "bullet",
    "link",
    "image",
  ];

  const recurringTypes = [
    { id: 1, name: "Day" },
    { id: 2, name: "Week" },
    { id: 3, name: "Month" },
    { id: 4, name: "Year" },
  ];

  return (
    <Box>
      <BackPageButton />

     
      <Typography sx={{
         fontSize: "20px",
         fontWeight: 600,
         color: "#01060B",
         marginBottom: "10px",
      }}>{id ? "Update Service" : "Add Service"}</Typography>
      {getLoading ? (
          <ListLoadingNew
          />
      ) : (
      <StyledBox>


        <form onSubmit={formik.handleSubmit}>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            <FormInputField
              placeholder="Enter service name"
              formik={formik}
              name="service_name"
              label="Service Name"
              showBorder
               borderRadius="8px"
               borderSize="0.5px"
              //  maxLength={50}
            />

            {/* <Box sx={{ position: 'relative' }}>
              <Typography
                sx={{ color: "#2C3034", mb: 1 }}
                variant="h4"
              >
                Description
              </Typography>
              <input
                type="file"
                id="attachment-description"
                style={{ visibility: "hidden", position: "absolute" }}
                onChange={handleImageChange}
                multiple
              />
              <CustomQuill
                theme="snow"
                value={formik.values.description}
                onChange={(content: string) => formik.setFieldValue("description", content)}
                placeholder="Enter service description..."
                modules={modules}
                formats={formats}
                ref={quillRef}
                style={{ minHeight: 250, maxHeight: 350, overflowY: 'auto' }}
              />
              {galleryImages.length > 0 && (
                <Box
                  sx={{
                    position: 'absolute',
                    left: 8,
                    right: 8,
                    bottom: 3,
                    display: 'flex',
                    gap: 2,
                    overflowX: 'auto',
                    padding: '8px 8px 8px 16px',
                    borderBottomLeftRadius: '12px',
                    borderBottomRightRadius: '12px',
                    zIndex: 2,
                    background: '#fff',
                  }}
                >
                  {galleryImages.map((src, idx) => (
                    <Box
                      key={src + idx}
                      sx={{
                        flex: '0 0 auto',
                        width: 42,
                        height: 42,
                        border: '1px solid #ccc',
                        borderRadius: '8px',
                        position: 'relative',
                        overflow: 'hidden',
                        background: '#fff',
                      }}
                    >
                      <img
                        src={src}
                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                        alt="preview"
                      />
                      <Button
                        size="small"
                        color="error"
                        onClick={() => handleRemoveImage(src)}
                        sx={{
                          position: 'absolute',
                          top: -8,
                          right: -8,
                          minWidth: 'unset',
                          fontSize: '1rem',
                          width: '24px',
                          height: '24px',
                          zIndex: 3,
                          background: '#fff',
                          border: '1px solid #ccc',
                          borderRadius: '50%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          p: 0,
                        }}
                      >
                        ×
                      </Button>
                    </Box>
                  ))}
                </Box>
              )}
            </Box> */}

            <FormInputField
              placeholder="Enter service description"
              formik={formik}
              name="description"
              label="Description"
              showBorder
              isMulti={true}
              rows={10}
              borderRadius="12px"
              // maxLength={1000}
              borderSize="2px"
            />

            <Box>
              <Typography sx={{ color: "#2C3034", mb: 1, marginTop: "14px" }} variant="h4">
                Pricing
              </Typography>
              <ToggleWrapper>
                <CustomToggle
                  type="button"
                  checked={formik.values.is_recurring}
                  aria-pressed={formik.values.is_recurring}
                  onClick={() => {
                    const newValue = !formik.values.is_recurring;
                    setIsRecurring(newValue);
                    formik.setFieldValue("is_recurring", newValue);
                    if (!newValue) {
                      formik.setFieldValue("recurring_amount", "");
                      formik.setFieldValue("recuring", "");
                      formik.setFieldValue("recurring_type", "");
                    }
                  }}
                />
                <Typography sx={{ fontWeight: 500 }}>
                  Recurring service
                </Typography>
              </ToggleWrapper>
            </Box>

            {!formik.values.is_recurring ? (
              <FormInputField
                  placeholder="200.00"
                formik={formik}
                name="price"
                label="Price"
                showBorder
                  maxLength={6}
                  borderRadius="8px"
                  type={"text"}
                  borderSize="0.5px"
                  numericOnly

              />



              ) : (
              <Box>
                <Typography sx={{ color: "#2C3034", mb: 1, minWidth: 120 }} variant="h4">
                  Recurring Price
                </Typography>
                <RecurringInputsFlex>
                  <RecurringInputWrapper>
                    <FormInputField
                      placeholder="200.00"
                      formik={formik}
                      name="price"
                      showBorder
                      // type={"number"}
                      type={"text"}
                      maxLength={6}
                      borderRadius="8px"
                      numericOnly
                      borderSize="0.5px"
                    />

                  </RecurringInputWrapper>
                  <RecurringInputWrapper>
                    <FormInputField
                      placeholder="every"
                      formik={formik}
                      name="recuring"
                      showBorder
                      type={"text"}
                      borderRadius="8px"
                      borderSize="0.5px"
                      noDecimal
                      numericOnly
                    />

                  </RecurringInputWrapper>
                  <RecurringInputWrapper>
                    <SelectInputField
                      formik={formik}
                      placeholder="Month"
                      menuData={recurringTypes}
                      name="recurring_type"
                      showBorder
                      sendValue
                      borderRadius="8px"
                      borderSize="0.5px"
                    />

                  </RecurringInputWrapper>
                </RecurringInputsFlex>
              </Box>
            )}


            <Box sx={{ display: "flex", justifyContent: "flex-start", mt: 3 }}>
              <CustomButton
                btnTitle={id ? "Update" : "Save"}
                type="submit"
                disabled={loading}
                loading={loading}
                minwidth="191px"
              />
            </Box>
          </Box>
        </form>
      </StyledBox>
          )}
    </Box>
  );
};

export default AddEditService;

interface OrderTitleProps {
  isClassName?: boolean;
}

export const StyledBox = muiStyled(Box)({
  background: "#ffffff",
  boxShadow: "0px 2px 40px 0px #DDE3EA33",
  borderRadius: "10px",
  padding: "40px",
});

export const StyledGridBox = muiStyled(Grid)(({ theme }) => ({
  border: "2px solid #EAF1FA",
  borderRadius: "12px",
}));

export const OrderTitle = muiStyled(Typography)<OrderTitleProps>(
  ({ isClassName }) => ({
    fontSize: "19px !important",
    color: "#01060B",
    paddingTop: isClassName ? "10px" : "20px",
    paddingBottom: "10px",
  })
);

export const StyledGridBoxChild = muiStyled(Grid)(({ theme }) => ({
  border: "1px solid #EAF1FA",
  borderRadius: "8px",
  padding: "20px",
}));

export const FormTItle = muiStyled(Typography)({
  fontSize: "14px !important",
  color: "#6C6F71",
  fontWeight: 500,
});

export const FormTItleValue = muiStyled(Typography)({
  width: "50%",
  fontSize: "14px !important",
  color: "#01060B",
  fontWeight: 500,
  display: "flex",
});

const CustomQuill = styled(ReactQuill)({
  ".ql-toolbar.ql-snow": {
    backgroundColor: "#EAF1FA91",
    borderTopLeftRadius: "12px",
    borderTopRightRadius: "12px",
    border: "2px solid #2977CC",
    padding: "10px",
  },
  ".ql-container.ql-snow": {
    border: "2px solid #2977CC",
    borderBottomLeftRadius: "12px",
    borderBottomRightRadius: "12px",
    height: "200px",
    overflowY: "auto",
  },
  ".ql-editor": {
    fontSize: "16px",
    color: "#2C3034",
  },
});